import {
  apiProductNatures,
  apiRetailFamilies,
  apiSports,
} from '@spo/services/api';
import { SelectOptions } from '../../types';

export const buildSportsOptionsFromSportsIds = async (
  sportIdsFromConfig: number[],
): Promise<SelectOptions[]> => {
  const sportsByIds = await apiSports.getSports({
    searchInput: '',
    sportIds: sportIdsFromConfig,
    page: 0,
    size: sportIdsFromConfig.length > 0 ? sportIdsFromConfig.length : 30,
    language: 'EN',
  });
  return sportsByIds
    .filter((sport) => sportIdsFromConfig.includes(sport.id))
    .map(({ id, name }) => ({
      label: `${id} - ${name}`,
      value: id,
      name: `${name}`,
    }));
};

export const buildProductNatureOptionsFromProductNatureIds = async (
  productNatureIds: number[],
): Promise<SelectOptions[]> => {
  const productNaturesByIds =
    await apiProductNatures.getProductNaturesReferentialByIds({
      productNatureIds,
      language: 'EN',
      search: '',
    });

  return productNaturesByIds
    ? productNaturesByIds.map((productNature) => ({
        label: productNature.englishName
          ? `${productNature.id} - ${productNature.englishName}`
          : `${productNature.id}`,
        value: productNature.id,
        name: `${productNature.englishName}`,
      }))
    : [];
};

export const buildRetailFamilyOptionsFromRetailFamilyIds = async (
  retailFamilyIds: number[],
  retailFamiliesDateFromConfig: string,
): Promise<SelectOptions[]> => {
  const familyIdsString = retailFamilyIds.map((itm) => itm.toString());
  const retailFamiliesByIds = await apiRetailFamilies.getRetailFamilies({
    date: retailFamiliesDateFromConfig,
    familyIds: retailFamilyIds.map((itm) => itm.toString()),
    search: '',
    limit: `${retailFamilyIds.length + 1}`,
    language: 'EN',
  });
  return retailFamiliesByIds
    ? retailFamiliesByIds
        .filter((rf) => familyIdsString.includes(rf.retailFamilyId))
        .map(({ retailFamilyId, name }) => ({
          label: `${retailFamilyId} - ${name}`,
          value: Number(retailFamilyId),
          name: `${name}`,
        }))
    : [];
};
